export default __webpack_public_path__ + "static/media/pronunciation.f9fd046b.jpg";